// extracted by mini-css-extract-plugin
module.exports = {"flex-container":"FlexContainer_flex-container__3rgTY","row":"FlexContainer_row__2qx2O","row-reverse":"FlexContainer_row-reverse__2Bzxz"};